/**
 * ELT: required terms acceptance before checkout (added Oct 10, 2026).
 * Adds an "I have read and agree" checkbox above every Checkout button (cart drawer and cart page),
 * blocks checkout until it is ticked, records the acceptance on the order as the cart attribute
 * "Terms accepted", and hides the Buy it now / express checkout buttons so every order goes through the cart.
 */
(function () {
  var KEY = 'eltTermsAccepted';
  var POLICY = '/policies/shipping-policy';

  var css = '' +
    '.shopify-payment-button, .additional-checkout-buttons { display: none !important; }' +
    '.elt-terms { display: flex; align-items: flex-start; gap: 10px; margin: 12px 0; padding: 10px 12px; border: 1px solid #e1e3e4; border-radius: 4px; background: #ffffff; color: #1e2d7d; font-size: 14px; line-height: 20px; text-align: left; cursor: pointer; white-space: normal; }' +
    '.elt-terms input { margin: 3px 0 0 0; flex-shrink: 0; width: 16px; height: 16px; }' +
    '.elt-terms a { text-decoration: underline; }' +
    '.elt-terms--error { border-color: #c8102e; }' +
    '.elt-terms__msg { display: none; margin: -6px 0 12px 0; font-size: 13px; color: #c8102e; text-align: left; }' +
    '.elt-terms--error + .elt-terms__msg { display: block; }' +
    '.elt-terms-locked { opacity: 0.5; cursor: not-allowed; }';
  var style = document.createElement('style');
  style.appendChild(document.createTextNode(css));
  document.head.appendChild(style);

  function get() { try { return sessionStorage.getItem(KEY) || ''; } catch (e) { return window.__eltTerms || ''; } }
  function set(v) { window.__eltTerms = v; try { if (v) { sessionStorage.setItem(KEY, v); } else { sessionStorage.removeItem(KEY); } } catch (e) {} }

  var SELECTOR = 'button[name="checkout"], input[name="checkout"]';

  function sync() {
    var stamp = get();
    var buttons = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < buttons.length; i++) {
      var btn = buttons[i];
      var form = btn.form || btn.closest('form');
      if (!form) continue;
      var box = form.querySelector('.elt-terms');
      if (!box) {
        box = document.createElement('label');
        box.className = 'elt-terms';
        box.innerHTML = '<input type="checkbox" class="elt-terms__check"><span>I have read and agree to the <a href="' + POLICY + '" target="_blank" rel="noopener">Shipping Policy</a>. I will inspect my delivery before accepting it, and I am responsible for providing a correct shipping address.</span>';
        var msg = document.createElement('p');
        msg.className = 'elt-terms__msg';
        msg.textContent = 'Please tick the box to agree before checking out.';
        var host = btn.classList.contains('cart-recap__checkout') ? btn : btn.parentNode;
        host.parentNode.insertBefore(box, host);
        host.parentNode.insertBefore(msg, host);
      }
      var check = box.querySelector('.elt-terms__check');
      if (check.checked !== !!stamp) check.checked = !!stamp;
      if (stamp) box.classList.remove('elt-terms--error');
      if (btn.classList.contains('elt-terms-locked') === !!stamp) btn.classList.toggle('elt-terms-locked', !stamp);
      var hidden = form.querySelector('input[name="attributes[Terms accepted]"]');
      if (stamp && !hidden) {
        hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'attributes[Terms accepted]';
        form.appendChild(hidden);
      }
      if (hidden) {
        if (stamp) { if (hidden.value !== stamp) hidden.value = stamp; } else { hidden.parentNode.removeChild(hidden); }
      }
    }
  }

  function saveAttribute(stamp) {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Terms accepted': stamp } })
      });
    } catch (e) {}
  }

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains('elt-terms__check')) return;
    var stamp = t.checked ? 'Yes, ' + new Date().toISOString() : '';
    set(stamp);
    saveAttribute(stamp);
    sync();
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
    if (!btn || get()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var form = btn.form || btn.closest('form');
    var box = form && form.querySelector('.elt-terms');
    if (box) { box.classList.add('elt-terms--error'); if (box.scrollIntoView) box.scrollIntoView({ block: 'center' }); }
  }, true);

  document.addEventListener('submit', function (e) {
    var s = e.submitter;
    if (s && s.name === 'checkout' && !get()) { e.preventDefault(); e.stopImmediatePropagation(); }
  }, true);

  var timer = null;
  function queue() { if (timer) return; timer = setTimeout(function () { timer = null; sync(); }, 80); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', sync); } else { sync(); }
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
})();
